// ProtectedRoute — обёртка для React Router, требующая аутентификации в «Упряжке».
// Если status='unauthenticated' → redirect на /login.
// Если status='initializing' → показывает loading.
// Если status='authenticated' → рендерит children.
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from '@/auth/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
}

/** Wrapper для защищённых routes. */
export function ProtectedRoute({ children }: ProtectedRouteProps): JSX.Element {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'initializing') {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
